<script lang="ts">
	import { onMount } from "svelte";
	import { beforeUpdate } from 'svelte';
  // 引入
  import { messageControl } from "./message.js";
  let subbmit = false;
  let messageComponent;
  let files;
  let uploadFiles = [];
  let productType = "";
  let data1 = {
    MAX_FILE_SIZE: 10 * 1000 * 1000,
    radio1: 0,
    radio2: 0,
    radio3: 0,
    opinion: "",
    fileUuidList: [],
    document: [],
    contact: "",
    radioName1: "",
    radioName2: "",
    radioName3: "",
    radioList1: [
      {
        label: 1,
        name: "低代码",
        value: "lowCode",
      },
      {
        label: 2,
        name: "零代码",
        value: "zeroCode",
      },
      {
        label: 3,
        name: "大屏",
        value: "largeScreen",
      },
      {
        label: 4,
        name: "城市",
        value: "city",
      },
      {
        label: 5,
        name: "园区",
        value: "park",
      },
      {
        label: 6,
        name: "拓扑",
        value: "topology",
      },
      {
        label: 7,
        name: "图表",
        value: "chart",
      },
      {
        label: 8,
        name: "学院/文档",
        value: "study",
      },
    ],
    radioList2: [
      {
        label: 1,
        name: "产品问题",
      },
      {
        label: 2,
        name: "优化建议",
      },
    ],
    radioList3: [
      {
        label: 1,
        name: "园区搭建",
      },
      {
        label: 2,
        name: "设置效果",
      },
      {
        label: 3,
        name: "其他",
      },
    ],
  };

	beforeUpdate(() => {
		const URL = window.location.href;
		const type = URL.split('?')[1];
    if (!type) return;

    const isTypeInList = data1.radioList1.some(item => item.value === type);
    const isCampusOrPark = type == "park" || type == "campus";
    
    if (isTypeInList || isCampusOrPark) {
      productType = isCampusOrPark ? "park" : type;
    }
    if (isCampusOrPark) {
      data1.radio1 = 5;
    }
	});

  function selectedList1(radio1) {
    data1.radio1 = radio1;
  }
  function selectedList2(radio2) {
    data1.radio2 = radio2;
  }
  function selectedList3(radio3) {
    data1.radio3 = radio3;
  }
  // 拖拽上传
  function fileDragover(e) {
    e.preventDefault();
  }
  function fileDrop(e) {
    e.preventDefault();
    const files = e.data1Transfer.files; // 获取到第一个上传的文件对象
    limitUpload(files);
  }
  // 点击上传
  onMount(()=>{
    const fileUploader = document.getElementById("many");
    fileUploader.addEventListener("change", (event) => {
      files = event.target["files"];
      limitUpload(files);
    });
  }) 
  async function limitUpload(files) {
    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];
      if (!file) return;
      // 初始化绑定
      messageComponent = new messageControl();
      if (file.size > data1.MAX_FILE_SIZE) {
        messageComponent.message({
          type: "error",
          content: "上传文件大小不能超过 10MB!",
        });
      } else {
        let uploadType = file.name.split(".")[1];
        if (uploadType == "png" || uploadType == "jpg" || uploadType == "pdf" || uploadType == "doc" || uploadType == "docx") {
					const formData = new FormData();
					formData.append('file', file);
					try{
						const res =  await fetch(`https://file.uino.com/saveFileAndReturn`, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            credentials: "include", // include, *same-origin, omit
						body: formData
          })
						let data = res.json()
						.then( (data2) => {
							messageComponent.message({
								type: "success",
								content: `${file.name} 提交成功`,
							});
							data1.fileUuidList = [...data1.fileUuidList, data2['uuid']];
							uploadFiles = [...uploadFiles, file.name];
							data1.fileUuidList = data1.fileUuidList;
							uploadFiles = uploadFiles;
						})
					}catch(error){
						messageComponent.message({
							type: "error",
							content: `${file.name} 上传失败`,
						});
					}
        } else {
          messageComponent.message({
            type: "error",
            content: "只能上传jpg、png、pdf、doc、docx格式",
          });
        }
      }
    }
  }
  // 叉掉已上传成功的文件
  function removeFile(fileName) {
    for (let i = 0; i < uploadFiles.length; i += 1) {
      if (fileName == uploadFiles[i]) {
        uploadFiles.splice(i, 1);
				data1.fileUuidList.splice(i, 1);
        uploadFiles = uploadFiles;
				data1.fileUuidList = data1.fileUuidList;
      }
    }
  }
  // 提交
  function sureBtn() {
    if (productType == "") {
      // stdio类型
      for (let i = 0; i < data1.radioList1.length; i += 1) {
        if (data1.radio1 == data1.radioList1[i].label) {
          data1.radioName1 = data1.radioList1[i].name;
        }
      }
    } else {
      // 产品类型已选
      for (let i = 0; i < data1.radioList1.length; i += 1) {
        if (productType == data1.radioList1[i].value) {
          data1.radioName1 = data1.radioList1[i].name;
        }
      }
    }
    for (let i = 0; i < data1.radioList2.length; i += 1) {
      if (data1.radio2 == data1.radioList2[i].label) {
        data1.radioName2 = data1.radioList2[i].name;
      }
    }
    for (let i = 0; i < data1.radioList3.length; i += 1) {
      if (data1.radio3 == data1.radioList3[i].label) {
        data1.radioName3 = data1.radioList3[i].name;
      }
    }
    console.log(data1.radioName1);
    console.log(data1.radioName2);
    console.log(data1.radioName3);
    console.log(data1.opinion);

    if (productType == "park" || data1.radio1 == 5) {
      if (data1.radioName1 == "" || data1.radioName2 == "" || data1.radioName3 == "" || data1.opinion == "") {
        // 初始化绑定
        messageComponent = new messageControl();
        messageComponent.message({
          type: "warning",
          content: "必填项*不能为空",
        });
      } else {
        submitBtn();
      }
    } else {
      if (data1.radioName1 == "" || data1.radioName2 == "" || data1.opinion == ""
      ) {
        // 初始化绑定
        messageComponent = new messageControl();
        messageComponent.message({
          type: "warning",
          content: "必填项*不能为空",
        });
      } else {
        submitBtn();
      }
    }
  }
  async function submitBtn() {
    messageComponent = new messageControl();
		// 上传到明道
		for (let i = 0; i < data1.fileUuidList.length; i += 1) {
			// 测试环境
			// const path = `http://resource-file.spacex.uino.local/getFile/${data1.fileUuidList[i]}`
			// 生产环境
			const path = `https://file.uino.com/getFile/${data1.fileUuidList[i]}`
			data1.document = [...data1.document, path];
			data1.document = data1.document;
		}
		const params1 = {
			产品类型: data1.radioName1,
			反馈类型: data1.radioName2,
			功能分类: data1.radioName3,
			意见描述: data1.opinion,
			上传文档: data1.document,
			联系方式: data1.contact,
		}
		const url = 'https://api.mingdao.com/workflow/hooks/NjIzMDUyYzVhY2E4ZjExNjc1YTcxYjM0'
		try{
			const res =  await fetch(url, {
			method: "POST", // *GET, POST, PUT, DELETE, etc.
			mode: "cors", // no-cors, *cors, same-origin
			// credentials: "include", // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
      },
			body: JSON.stringify(params1)
		})
			let data = res.json()
			.then( (data2) => {
				if (data2['status'] == 1) {
					messageComponent.message({ type: "success", content: "提交成功" });
					empty();
				}
			})
		}catch(error){			
			messageComponent.message({ type: "error", content: "提交失败" });
		}
  }
  function empty() {
    data1.radio1 = 0;
    data1.radio2 = 0;
    data1.radio3 = 0;
    data1.opinion = "";
    data1.document = [];
    data1.contact = "";
    subbmit = true;
  }
</script>

<main>
  <div class="com-module-main">
    <div class="com-module-module-main">
      <div class="header bm bm-ac">
        <img class="logo" src="logo.svg" alt="logo" />
      </div>
      {#if subbmit == false}
        <div class="collage-main-test">
          <div class="college-title">
            <div class="college-title-header">
              <div class="college-header">意见反馈</div>
              <div class="title-margin" style="text-align: center;">
                感谢您抽出宝贵的时间为我们的产品提出建议
              </div>
            </div>
            <hr />
            <div class="college-title-margin">
              <div class="title-tips">* 为必填项</div>
              {#if productType == ""}
                <div>
                  <div class="title-header">* 1.产品类型</div>
                  <form class="title-radio" value={data1.radio1}>
                    {#each data1.radioList1 as radioList1 (radioList1.label)}
                      <label for={"radio1." + radioList1.label}>
                        <input
                          id={"radio1." + radioList1.label}
                          class="option-radio"
                          type="radio"
                          name="radio1"
                          value={radioList1.label}
                          on:click={() => selectedList1(radioList1.label)}
                        />
                        {radioList1.name}
                      </label>
                      <!-- <br /> -->
                    {/each}
                  </form>
                </div>
              {/if}
              {#if data1.radio1 == 5}
                {#if productType == ""}
                  <div class="title-park-margin">
                    <div class="title-park-header">* 请选择功能分类：</div>
                    <form class="title-radio" value={data1.radio3}>
                      {#each data1.radioList3 as radioList3 (radioList3.label)}
                        <label for={"radio3." + radioList3.label}>
                          <input
                            id={"radio3." + radioList3.label}
                            class="option-radio"
                            type="radio"
                            name="radio3"
                            value={radioList3.label}
                            on:click={() => selectedList3(radioList3.label)}
                          />
                          {radioList3.name}
                        </label>
                      {/each}
                    </form>
                  </div>
                {:else if productType == "park"}
                  <div>
                    <div class="title-header">* 1.请选择功能分类：</div>
                    <form class="title-radio" value={data1.radio3}>
                      {#each data1.radioList3 as radioList3 (radioList3.label)}
                        <label for={"radio3." + radioList3.label}>
                          <input
                            id={"radio3." + radioList3.label}
                            class="option-radio"
                            type="radio"
                            name="radio3"
                            value={radioList3.label}
                            on:click={() => selectedList3(radioList3.label)}
                          />
                          {radioList3.name}
                        </label>
                      {/each}
                    </form>
                  </div>
                {/if}
              {/if}
              <div>
                {#if productType == "" || productType == "park"}
                  <div class="title-header">* 2.反馈类型</div>
                	{:else}<div class="title-header">* 1.反馈类型</div>
                {/if}
                <form class="title-radio" value={data1.radio2}>
                  {#each data1.radioList2 as radioList2 (radioList2.label)}
                    <label for={"radio2." + radioList2.label}>
                      <input
                        id={"radio2." + radioList2.label}
                        class="option-radio"
                        type="radio"
                        name="radio3"
                        value={radioList2.label}
                        on:click={() => selectedList2(radioList2.label)}
                      />
                      {radioList2.name}
                    </label>
                  {/each}
                </form>
              </div>
              <div>
                {#if productType == "" || productType == "park"}
                  <div class="title-header">* 3.意见描述</div>
                {:else}<div class="title-header">* 2.意见描述</div>
                {/if}
                <div class="title-margin">请提出您的建议，帮助我们做的更好</div>
                <textarea class="textarea" rows="3" bind:value={data1.opinion} />
              </div>
              <div style="width: 100%;">
                {#if productType == "" || productType == "park"}
                  <div class="title-header">4.上传文档</div>
                {:else}<div class="title-header">3.上传文档</div>
                {/if}
                <div
                  class="drag-area"
                  on:dragover={fileDragover}
                  on:drop={fileDrop}
                >
                  <div class="uploader-tips">
                    <div style="margin-bottom: 2%;">将文件拖到此处</div>
                    <input
                      class="input-upload"
                      bind:files
                      id="many"
                      multiple
                      type="file"
                    />
                    <button style="width: 40%; margin-left: -40%;"
                      >选择文件上传</button
                    >
                  </div>
                </div>
                <div>
                  {#if uploadFiles}
                    {#each uploadFiles as file}
                      <div class="upload-File">{file}</div>
                      <div
                        class="remove-upload-File"
                        on:click={() => removeFile(file)}
                      >
                        ×
                      </div>
                    {/each}
                  {/if}
                </div>
                <ul id="ul1" />
              </div>
              <div>
                {#if productType == "" || productType == "park"}
                  <div class="title-header">
                    5.您可以留下联系方式，便于我们向您提供进一步反馈
                  </div>
                {:else}<div class="title-header">
                    4.您可以留下联系方式，便于我们向您提供进一步反馈
                  </div>
                {/if}
                <div class="title-margin">手机号、微信号、QQ号、邮箱均可</div>
                <input
                  class="title-input"
                  type="text"
                  name="firstname"
                  bind:value={data1.contact}
                />
              </div>
              <input class="sure-btn" type="submit" on:click={sureBtn} />
            </div>
          </div>
        </div>
      {:else if subbmit == true}
        <div class="college-tips">
          <div class="sure-subbmit">感谢您的反馈</div>
          <img class="icon" src="icons8-ok-50.png" alt="logo" />
        </div>
      {/if}
    </div>
  </div>
</main>

<style>
  .com-module-main {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 1000px;
    z-index: -10;
    zoom: 1;
    -o-background-size: cover;
    background-position: center 0;
  }
  .com-module-module-main {
    text-align: center;
  }
  .collage-main-test {
    position: fixed;
    width: 40%;
    height: calc(100% - 100px);
    margin: 1% 30% 0 30%;
    background-color: #fff;
    box-shadow: 2px 2px 10px #909090;
  }
  .college-title {
    height: calc(100% - 60px);
    margin: 5% 10% 0 10%;
    overflow-y: auto;
    text-align: left;
  }
  /* 隐藏滚动条 */
  .college-title::-webkit-scrollbar {
    display: none;
  }
  /* 横线上方部分 */
  .college-title-header {
    text-align: center;
  }
  .college-header {
    font-weight: 600;
    color: #414549;
    font-size: 20px;
  }
  /* 顶部提示 */
  .title-tips {
    color: #6da0e3 !important;
    text-align: center;
    font-size: 12px;
  }
  /* 标题文字 */
  .title-header {
    margin: 6% 0 3% 0;
    color: #655a5a;
    font-weight: 600;
    font-size: 16px;
  }
  /* 小字提示 */
  .title-margin {
    margin: 2% 0 2% 0;
    color: #beb7b7;
    font-size: 10px;
  }
  input {
    margin: 6px 0 0.5em 0;
  }
  hr {
    height: 1px;
    background-color: #ddd9d9;
    border: none;
    margin: 5% 0;
  }
  /* 选项文字 */
  .title-radio {
    font-size: 13px;
    color: rgb(104, 99, 99);
  }
  .option-radio {
    margin-right: 1.5%;
  }
  /* 园区功能分类 */
  .title-park-margin {
    margin-left: 2%;
    margin-top: -11%;
  }
  /* 园区分类标题 */
  .title-park-header {
    margin: 15% 0 2% 0;
    font-size: 12px;
  }
  .textarea {
    padding: 2%;
    height: 10%;
    width: 100%;
    border: none;
    font-size: 15px;
    box-shadow: inset 1px 1px 10px #dbdbdb !important;
  }
  .textarea:focus {
    outline: none;
  }
  .title-input {
    width: 100%;
    height: 4%;
    border: none;
    box-shadow: inset 1px 1px 10px #dbdbdb !important;
  }
  .title-input:focus {
    outline: none;
  }
  /* 提交 */
  .sure-btn {
    width: 35%;
    height: 5%;
    margin-top: 10%;
    margin-left: 30%;
    color: #fff;
    background-color: #41464a;
  }
  /* 头部标题栏 */
  .header {
    display: inline-flex;
    box-sizing: border-box;
    width: 100%;
    height: 64px;
    padding: 0 32px;
    box-shadow: 0 8px 32px 0 #dbdbdb75;
    user-select: none;
  }
  .logo {
    width: 167px;
    height: 22px;
    margin-top: 20px;
  }
  /* 文件上传 */
  .drag-area {
    width: 99%;
    text-align: center;
    border: dashed 1px #ccc;
    margin-bottom: 10px;
    color: #777;
    box-shadow: inset 1px 1px 10px #dbdbdb;
  }
  .uploader-tips {
    margin-top: 15px;
  }
  .input-upload {
    width: 40%;
    border: none;
    opacity: 0;
  }
  .upload-File {
    width: 95%;
    display: inline-block;
    margin-top: 10px;
    font-size: 13px;
  }
  .remove-upload-File {
    display: inline-block;
  }
  .remove-upload-File:hover {
    cursor: pointer;
  }
  /* 提交成功反馈 */
  .college-tips {
    position: fixed;
    width: 40%;
    height: calc(50% - 100px);
    margin: 1% 30% 0 30%;
    background-color: #fff;
    box-shadow: 2px 2px 10px #909090;
    text-align: center;
  }
  .sure-subbmit {
    margin-top: 17%;
    font-size: 23px;
  }
  .icon {
    margin-top: 5%;
  }
</style>
